import { render, staticRenderFns } from "./WorkspaceCreateWrapper.vue?vue&type=template&id=10854134"
import script from "./WorkspaceCreateWrapper.vue?vue&type=script&lang=js"
export * from "./WorkspaceCreateWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports